import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { CALCULO_ITENS, INavItem, NAV_ITEMS4, NAV_LEGISLACAO_ARQUIVOS_PA, NAV_LEGISLACAO_RS, NAV_LEGISLACAO_TABELAS_PA, NAV_RELATORIO, XMLS_ITEMS, XMLS_ITEMS_SUB } from "./NavItens";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Collapse } from "@mui/material";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { AppIcon } from "../utils/AppIcon";

require("../../assets/css/components/NavMenu.css");

export interface Props {
  onClick: (value: string) => void;
  isOpen: boolean
}

interface State {
  declaracoes: boolean
  xmls: boolean
  solicitacao: boolean
  calculos: boolean
  legislacao: boolean
  arquivos: boolean
  tabelas: boolean
  relatorios: boolean
}

@observer
export default class NavMenuMobile extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      declaracoes: false,
      xmls: false,
      solicitacao: false,
      calculos: false,
      legislacao: false,
      arquivos: false,
      tabelas: false,
      relatorios: false
    };

  }

  /**
    * O método `componentDidUpdate` é um lifecycle method do React que é chamado 
    * imediatamente após uma atualização do componente (quando as `props` ou o `state` mudam).
    * 
    * @param {Readonly<Props>} prevProps - As propriedades anteriores do componente antes da atualização.
    * 
    * Este método verifica se a propriedade `isOpen` mudou de `true` para `false`.
    * Se isso acontecer, ele chama o método `handleCloseMenus`.
    * 

  */
  componentDidUpdate(prevProps: Readonly<Props>) {

    if (prevProps.isOpen && !this.props.isOpen) {

      this.handleCloseMenus()

    }

  }

  /**
    * O método `handleCloseMenus` é responsável por atualizar o estado do componente, 
    * garantindo que todas as propriedades relacionadas a menus sejam fechadas.
  */
  handleCloseMenus() {

    this.setState({
      declaracoes: false,
      xmls: false,
      solicitacao: false,
      calculos: false,
      legislacao: false,
      arquivos: false,
      tabelas: false,
      relatorios: false
    })

  }

  /**
    * O método `renderItem` é responsável por renderizar uma lista de itens de navegação
    * (`INavItem[]`). Para cada item, ele gera um componente `ListItemButton` que,
    * quando clicado, aciona o método `onClick` passado via `props`, enviando a chave (`key`)
    * do item correspondente.
    * 
    * @param {INavItem[]} item - Um array de objetos que representam os itens de navegação.
    * Cada objeto deve conter as propriedades:
    *   - `key: string` → Identificador único do item.
    *   - `text: string` → Texto exibido na lista.
    * 
    * @returns {JSX.Element} - Retorna um fragmento (`<>...</>`) contendo uma lista de 
    * botões (`ListItemButton`), um para cada item fornecido no array.
  */
  renderItem = (item: INavItem[]): JSX.Element => {

    return (<>

      {item.map((setting) => (
        <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
          <ListItemText className='btn-list-header' primary={setting.text} />
        </ListItemButton>
      ))}

    </>);
  };

  /**
   * O método `renderDashboard` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Dashboard").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderDashboard(): JSX.Element {

    return (

      <ListItemButton onClick={() => this.props.onClick("/dashboard")}>
        <ListItemText className='btn-list-header' primary="Dashboard" />
      </ListItemButton>

    )

  }

  /**
   * O método `renderEmpresas` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Empresas").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderEmpresas(): JSX.Element {

    return (
      <ListItemButton onClick={() => { EmpresaStore.obs.certificado = ""; EmpresaStore.obs.status = ""; this.props.onClick("/empresas") }}>
        <ListItemText className='btn-list-header' primary="Empresas" />
      </ListItemButton>
    )
  }

  /**
   * O método `renderDeclaracoes` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Declarações").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderDeclaracoes(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ declaracoes: !this.state.declaracoes })
      }}>
        <ListItemText className='btn-list-header' primary="Declarações" />
        {this.state.declaracoes ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.declaracoes} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {NAV_ITEMS4.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderXmlsRS` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("XMLs").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderXmlsRS(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ xmls: !this.state.xmls })
      }}>
        <ListItemText className='btn-list-header' primary="XMLs" />
        {this.state.xmls ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.xmls} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {XMLS_ITEMS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderXmlsPA` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("XMLs").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderXmlsPA(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ xmls: !this.state.xmls })
      }}>
        <ListItemText className='btn-list-header' primary="XMLs" />
        {this.state.xmls ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.xmls} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          {XMLS_ITEMS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}

          <ListItemButton sx={{ pl: 4 }} onClick={() => {
            this.setState({ solicitacao: !this.state.solicitacao })
          }}>
            <ListItemText className='btn-list-header' primary="Solicitações de Arquivos" />
            {this.state.solicitacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.solicitacao} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>

              {XMLS_ITEMS_SUB.map((setting) => (
                <ListItemButton sx={{ pl: 8 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}

            </List>
          </Collapse>
        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderCalculos` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Cálculos").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderCalculos(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ calculos: !this.state.calculos })
      }}>
        <ListItemText className='btn-list-header' primary="Cálculos" />
        {this.state.calculos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.calculos} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {CALCULO_ITENS.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderLegislacaoPA` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Legislaçao").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderLegislacaoPA(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ legislacao: !this.state.legislacao })
      }}>
        <ListItemText className='btn-list-header' primary="Pará" />
        {this.state.legislacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ arquivos: !this.state.arquivos })
          }}>
            <ListItemText className='btn-list-header' primary="Arquivos" />
            {this.state.arquivos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.arquivos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_ARQUIVOS_PA.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ tabelas: !this.state.tabelas })
          }}>
            <ListItemText className='btn-list-header' primary="Tabelas" />
            {this.state.tabelas ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.tabelas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_TABELAS_PA.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderLegislacaoRS` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Legislaçao").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderLegislacaoRS(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ legislacao: !this.state.legislacao })
      }}>
        <ListItemText className='btn-list-header' primary="Rio Grande do Sul" />
        {this.state.legislacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          <ListItemButton sx={{ pl: 8 }} onClick={() => {
            this.setState({ tabelas: !this.state.tabelas })
          }}>
            <ListItemText className='btn-list-header' primary="Tabelas" />
            {this.state.tabelas ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
          </ListItemButton>

          <Collapse in={this.state.tabelas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {NAV_LEGISLACAO_RS.map((setting) => (
                <ListItemButton sx={{ pl: 12 }} onClick={() => this.props.onClick(setting.key)}>
                  <ListItemText className='btn-list-header' primary={setting.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>
      </Collapse>

    </>)

  }

  /**
   * O método `renderRelatorios` é responsável por renderizar um botão de navegação 
   * específico para o painel de controle ("Relatórios").
   * 
   * @returns {JSX.Element} - Retorna um componente `ListItemButton`.
  */
  renderRelatorios(): JSX.Element {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus()
        this.setState({ relatorios: !this.state.relatorios })
      }}>
        <ListItemText className='btn-list-header' primary="Relatórios" />
        {this.state.relatorios ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.relatorios} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {NAV_RELATORIO.map((setting) => (
            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onClick(setting.key)}>
              <ListItemText className='btn-list-header' primary={setting.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>

    </>)

  }

  renderLegislacao() {

    return (<>

      <ListItemButton onClick={() => {
        this.handleCloseMenus();
        this.setState({ legislacao: !this.state.legislacao })
      }}>
        <ListItemText className='btn-list-header' primary="Legislação" />
        {this.state.legislacao ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
      </ListItemButton>

      <Collapse in={this.state.legislacao} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {this.renderLegislacaoPA()}
          {this.renderLegislacaoRS()}
        </List>
      </Collapse>

    </>)

  }

  render() {

    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.permissao : null;

    return (

      <div className="ul-menu" style={{ color: "#3e6971" }}>
        {!userPermissao ? (
          <>
            {this.renderDashboard()}
            {this.renderEmpresas()}
            {this.renderDeclaracoes()}
            {/* {AppStore.obs1.usuario.conta.uf === "PA" || AppStore.obs1.usuario.conta.estado === "PA"
              ? this.renderXmlsPA()
              : this.renderXmlsRS()
            } */}
            {this.renderXmlsPA()}
            {this.renderCalculos()}
            {/* {AppStore.obs1.usuario.conta.uf === "PA" || AppStore.obs1.usuario.conta.estado === "PA"
              ? this.renderLegislacaoPA()
              : this.renderLegislacaoRS()} */}
            {this.renderLegislacao()}
            {this.renderRelatorios()}
          </>
        ) : (
          this.renderDashboard()
        )}
      </div>

    );

  }

}
